import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { nonLogsRider, nonLogsBgImg, headPhone } from '../../../images/images';
import { Address } from '../Order';
import { valetModel } from '../../../api';
import { CopyText } from '../../../UiKit';

import './NonLogsDelivery.scss';

export default class NonLogsDelivery extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.order === nextProps.order) {
      return false;
    } else {
      return true;
    }
  }
  render() {
    const { order } = this.props;
    return (
      <div className='nonLogsDeliveryBox row'>
        {!order ? (
          <Shimmer height='100%' width='100%' />
        ) : (
          <NonLogsDeliveryComp {...this.props} />
        )}
      </div>
    );
  }
}

class NonLogsDeliveryComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valet: null,
    };
  }

  componentDidMount() {
    this.getValetInfo();
  }

  getValetInfo = () => {
    const { orderId } = this.props;
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    valetModel.getValetData(queryStrings).then((response) => {
      if (!response || (response && response.isError === true)) return null;
      this.setState({
        valet: { ...response },
      });
    });
  };
  render() {
    const { order, isOrderShimmer, orderId, isWFH } = this.props;
    const { valet } = this.state;
    let valetTitle = valet && valet.title ? valet.title : 'Restaurant Delivery';
    let valetName = valet && valet.name ? valet.name : null;
    let valetPhoneNumber =
      valet && valet.phone_number ? valet.phone_number : null;

    if (!order || !order.order) return null;
    let nonLogsBackgroundImg = {
      backgroundImage: `url(${nonLogsBgImg})`,
      backgroundSize: 'cover',
    };
    const { non_logs_status } = order.order;

    return (
      <div className='nonLogsDelivery col'>
        <p className='lighter'>
          <span role='img' aria-label='bike'>
            🛵
          </span>
          {valetTitle}
        </p>
        {valetName && (
          <h3 className='valetName dark mt3' data-dd-privacy='mask'>
            <p className='dark large'>{valetName}</p>
          </h3>
        )}
        {valetPhoneNumber && (
          <div className='mt3' data-dd-privacy='mask'>
            <span className='icon iconMarginR'>
              <img src={headPhone} alt='' />
            </span>
            <CopyText
              title={valetPhoneNumber}
              isWFH={isWFH}
              orderId={orderId}
              masking={true}
              maskingCount={4}
              maskEverything={true}
            />
          </div>
        )}
        <div className='nonLogsDeliveryContent' style={nonLogsBackgroundImg}>
          <div className='riderImage' data-dd-privacy='mask'>
            <img
              src={
                (non_logs_status && non_logs_status.image_url) || nonLogsRider
              }
              alt=''
            />
          </div>
          <p className='deliveryTime small' data-dd-privacy='mask'>
            {(non_logs_status && non_logs_status.text) ||
              order.order.status_string}
          </p>
          <Address
            order={order}
            isLog={false}
            isOrderShimmer={isOrderShimmer}
          />
        </div>
      </div>
    );
  }
}
